function adjustSlider() {
  var sliders = document.querySelector('.video-slider');
    var flkty = new Flickity(sliders, {
      cellAlign: 'center',
      contain: true,
      wrapAround: true,
      pageDots: false,
      prevNextButtons: false,
    });
    sliders.classList.add('spring-slider-visible');
}
  adjustSlider();

document.addEventListener("DOMContentLoaded", function() {
  var videoLayoutPays = document.querySelectorAll(".video-layout-pay");

  videoLayoutPays.forEach(function(videoLayoutPay) {
    videoLayoutPay.addEventListener("click", function(e) {
      var video = this.parentElement.querySelector(".product-item__video");
      if (video && typeof video.play === "function") {
        video.play();
        this.style.display = "none";
      }
    });
  });

  var productVideos = document.querySelectorAll(".product-item__video");
  productVideos.forEach(function(video) {
    video.addEventListener("mouseover", function(e) {
      if (typeof this.play === "function") {
        this.play();
        var videoLayoutPay = this.parentElement.querySelector(".video-layout-pay");
        if (videoLayoutPay) {
          videoLayoutPay.style.display = "none";
        }
      }
    });

    video.addEventListener("mouseout", function(e) {
      if (typeof this.pause === "function") {
        this.pause();
        var videoLayoutPay = this.parentElement.querySelector(".video-layout-pay");
        if (videoLayoutPay) {
          videoLayoutPay.style.display = "flex";
        }
      }
    });
  });
});


function reviewSliders() {
   var slidersreview = document.getElementById('custom-reviews-slider');
   if (slidersreview) {
      var flkty = new Flickity(slidersreview, {
         wrapAround: true,
         fullscreen: true,
         contain: true,
         pageDots: false,
             prevNextButtons: false,
       cellAlign: 'left',
      });
      slidersreview.classList.add('spring-slider-visible');
   }
}
reviewSliders();